import React, { useEffect } from 'react';
import { logPayment } from '../../redux/buyCourse/buyCourse.actions';
import { connect } from 'react-redux';
import { getParameterByName } from '../../utils/commonFunctions';

const PaymentProcess = ({ logPayment }) => {
	useEffect(() => {
		localStorage.setItem('payment_type', getParameterByName('payment_type'));
	}, []);
	useEffect(() => {
		logPayment();
		document.getElementById('chat-circle').style.display = 'none';
		return () => {
			document.getElementById('chat-circle').style.display = 'block';
		};
	}, [logPayment]);

	return null;
};

const mapDispatchToProps = (dispatch) => {
	return {
		logPayment: () => dispatch(logPayment()),
	};
};

export default connect(null, mapDispatchToProps)(PaymentProcess);
